import React from 'react';
import { Debounce } from 'utils/helperMethods';
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';

import { useTranslation } from 'react-i18next';
import useStyles from './useStyles';

const Search = props => {
  const { onChange } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  const debouncedSearchChange = Debounce(searchFields => {
    onChange(searchFields);
  });

  const handleChange = ({ target: { value } }) => debouncedSearchChange(value);

  return (
    <TextField
      variant="outlined"
      placeholder={t('components.LoanOfficerRealEstateAgents.Search.placeholder')}
      onChange={handleChange}
      type="text"
      fullWidth
      className={classes.field}
      InputLabelProps={{
        shrink: false,
      }}
    />
  );
};

Search.propTypes = {
  onChange: PropTypes.func.isRequired,
};
export default Search;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerRealEstateAgents/components/Search/Search.js